import ViewHeader from "../../../viewHeader/viewHeader";
import { LineChartSolid2Filled } from "@tag/tag-icons";
import DishForecastTable from "./dishSalesTable/dishForecastTable";
import { useState } from "react";
import ForecastTableFilters from "./forecastTableFilters/forecastTableFilters";
import ProductUsageTable from "./productUsageTable/productUsageTable";
import { useForecastContext } from "../../../../context/forecastContext";
import SkeletonLoader from "../../../SkeletonLoader";
import ErrorMessage from "../../../errorMessage/errorMessage";
import "./forecastTable.css";
import { useForecastQuery } from "../../../../services/forecastService";
import dayjs from "dayjs";
import { findForecastForDay } from "../../../../utilities/forecastHelpers";

export type ForecastTableType = "dishSales" | "productUsage";

const ForecastTable: React.FC = () => {
  const { forecastState, setModalVisible, onManualForecastChange } =
    useForecastContext();
  const [selectedTable, setSelectedTable] =
    useState<ForecastTableType>("dishSales");

  const {
    data: forecasts,
    isLoading,
    isError,
  } = useForecastQuery({
    mdrSiteId: forecastState.selectedSite?.mdrSiteId!,
    siteId: forecastState.selectedSite?.siteId!,
    orgId: forecastState.selectedSite?.organisationId!,
    searchPeriod: forecastState.searchPeriod,
  });

  if (isLoading) {
    return <SkeletonLoader />;
  }
  if (isError) {
    return <ErrorMessage dataType="Forecast" fontSize="13px" />;
  }

  const forecast = findForecastForDay(
    dayjs(forecastState.selectedDate).format("YYYY-MM-DD"),
    forecasts ?? []
  );

  // if (!forecast) {
  //   return <SkeletonLoader />;
  // }

  if (!forecast) {
    return <>No Data</>;
  }

  return (
    <div className="forecast-table-container">
      <ViewHeader
        icon={<LineChartSolid2Filled accent="teal" />}
        title={
          selectedTable === "dishSales"
            ? "Dish Sales Forecast"
            : "Product Usage Forecast"
        }
        filters={
          <ForecastTableFilters
            value={selectedTable}
            onToggleChange={setSelectedTable}
            onSave={setModalVisible}
            onClear={() => onManualForecastChange(undefined)}
          />
        }
      />
      <div className="forecast-sales-table">
        {selectedTable === "dishSales" && <DishForecastTable />}
        {selectedTable === "productUsage" && <ProductUsageTable />}
      </div>
    </div>
  );
};

export default ForecastTable;
